export const DAYS_SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export function formatDate(d) {
  return d.toISOString().split('T')[0];
}

export function formatShortDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T12:00:00');
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function getDayName(dateStr) {
  const d = new Date(dateStr + 'T12:00:00');
  return DAYS_SHORT[d.getDay() === 0 ? 6 : d.getDay() - 1];
}

export function getPayPeriodDates(startStr, endStr) {
  const dates = [];
  const start = new Date(startStr + 'T12:00:00');
  const end = new Date(endStr + 'T12:00:00');
  const cur = new Date(start);
  while (cur <= end) {
    dates.push(formatDate(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return dates;
}

export const statusColors = {
  Draft: 'bg-muted text-muted-foreground border-border',
  Submitted: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  Approved: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  Rejected: 'bg-destructive/10 text-destructive border-destructive/20',
};
